export default [
  {
    path: "/overview",
    name: "Overview",
    meta: { title: "Overview", key: "OverviewIndex" },
    component: () => import("../views/overview/index.vue")
  }
]